import service from '../api/request'
import { Message, MessageBox } from 'element-ui'
import { Base64 } from 'js-base64'
/* 时间转化为 yyyy-mm-dd 格式 */
export function dateFormat(type, val) {
    const date = val ? val : new Date()
    let result
    if (type === 'yyyy-mm-dd') {
        result = date.getFullYear() + "-" + pad(date.getMonth() + 1) + "-" + pad(date.getDate())
    } else if (type === 'yyyy-MM') {
        result = date.getFullYear() + "-" + pad(date.getMonth() + 1)
    }else if (type === 'yyyy-MM-dd hh:ss:mm') {
        result = date.getFullYear() + pad(date.getMonth() + 1) + pad(date.getDate()) + "_" + pad(date.getHours()) + pad(date.getMinutes()) + pad(date.getSeconds())
    } else {
        result = date.getFullYear() + "-" + pad(date.getMonth() + 1) + "-" + pad(date.getDate()) + " " + pad(date.getHours()) + ":" + pad(date.getMinutes()) + ":" + pad(date.getSeconds())
    }
    return result
}

export function dateFormatCN(type, val) {
    const date = new Date() || val
    let result
    if (type === 'yyyy年mm月dd日') {
        result = date.getFullYear() + "年" + pad(date.getMonth() + 1) + "月" + pad(date.getDate() + "日")
    } else {
        result = date.getFullYear() + "年" + pad(date.getMonth() + 1) + "月" + pad(date.getDate()) + "日 " + pad(date.getHours()) + "时" + pad(date.getMinutes()) + "分" + pad(date.getSeconds()) + "秒"
    }
    return result
}

export function dateFormatNum() {
    const date = new Date()
    return date.getFullYear() + pad(date.getMonth() + 1)+ pad(date.getDate()) + pad(date.getHours()) + pad(date.getMinutes()) + pad(date.getSeconds())
}

// 检测数字是 个位 还是 十位
export function pad(val, len) {
    val = String(val);
    len = len || 2;
    while (val.length < len) {
        val = '0' + val;
    }
    return val;
}

// 路由提取到一级 返回数组
export function initRoutes(arr, pid) {
    let parentName = pid ? pid : 'parentName'
    // 数组深拷贝
    let _data = JSON.parse(JSON.stringify(arr))
    let resArr = []

    while (_data.length) {
        // 删除第一个元素并返回 删除的数据
        const node = _data.shift();
        if (node.children && node.children.length) {
            _data.push(...node.children);
        }
        delete node.children;
        if (node[parentName] !== null && node[parentName] !== undefined) {
            resArr.push(node);
        }
    }
    
    return resArr
}

// 转化 路由 component 对象
export function lazyLoading(url) {
    return () => import(`@/${url}.vue`)
}

// 跟踪返回的动态数组  渲染成  动态路由 --- mockjs 数据
export function addRoutes(resArr, arr) {
    arr.forEach(item => {
        let _menuObj = Object.assign({}, item)
        _menuObj.component = lazyLoading(item.component)

        if (item.children && item.children.length > 0) {
            _menuObj.children = []
            addRoutes(_menuObj.children, item.children)
        }

        resArr.push(_menuObj)
    })

    return resArr
}

// 真实菜单接口数据 处理
export function addActualRoutes(resArr, arr) {
    arr.forEach(item => {
        let _menuObj = Object.assign({}, item)
        _menuObj.component = lazyLoading(item.componentPath)
        _menuObj.name = item.componentName
        _menuObj.meta = {
            title: item.sname
        }
        if (_menuObj.children && _menuObj.children.length === 0) {
            delete(_menuObj.children)
        }

        if (item.children && item.children.length > 0) {
            _menuObj.redirect = item.children[0].path
            _menuObj.children = []
            addActualRoutes(_menuObj.children, item.children)
        }

        resArr.push(_menuObj)
    })

    return resArr
}

// 数组深拷贝
export function $deepCopy(source) {
    let stringify = JSON.stringify(source)
    return JSON.parse(stringify)
}

// 取地址栏参数
export function param2Obj(url) {
    const search = url.split('?')[1]
    if (!search) {
        return {}
    }
    return JSON.parse(
        '{"' +
        decodeURIComponent(search)
            .replace(/"/g, '\\"')
            .replace(/&/g, '","')
            .replace(/=/g, '":"') +
        '"}'
    )
}

// 树结构转换 json 
export function treeToJson(array, pid) {
    const list = [];
    // 声明cache变量，便于匹配是否有循环引用的情况
    let cache = [];
    if (array) {
        // 处理 对于 循环调用的对象的 转换
        let str = JSON.stringify(array, function (key, value) {
            if (typeof value === "object" && value !== null) {
                if (cache.indexOf(value) !== -1) {
                    // 移除
                    return;
                }
                // 收集所有的值
                cache.push(value);
            }
            return value;
        });
        cache = null; // 清空变量，便于垃圾回收
        // 数组深拷贝
        const _data = JSON.parse(str);
        while (_data.length) {
            // 删除第一个元素并返回 删除的数据
            const node = _data.shift();
            if (node.children && node.children.length) {
                _data.push(...node.children);
            }
            delete node.children;
            if (node[pid] !== null && node[pid] !== undefined) {
                list.push(node);
            }
        }
    }
    return list;
}

// 获取某个模块下面的全部 文件
// export function getAllFiles(folder, type) {
//     const modulesFiles = require.context('../mock/modules', true, `/\.${type}$/`)

//     let filesList = []
//     modulesFiles.keys().reduce((modules, modulePath) => {
//         const value = modulesFiles(modulePath)

//         filesList.push(...value.default)
//     }, {})

//     return filesList
// }


// 导出Excel公用方法
export function exportExcel(url, params, fileName) {
    return new Promise((resolve, reject) => {
        service({
            method: 'post',
            url: url,
            data: params,
            responseType: 'blob',
            timeout: 100000
        }).then((res) => {
            // console.log(res)
            const link = document.createElement('a')
            // let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
            let blob = new Blob([res.data], { type: res.data.type })
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)

            // link.download = res.headers['content-disposition'] //下载后文件名
            link.download = fileName || 'xxx' //下载的文件名
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            Message.success('导出成功！')

            resolve(true)
        }).catch(error => {
            // reject()
            console.log(error)
        })
    })
}

// 删除确认公共提示
export function deleteConfirm(text, type) {
    let textInfo = type ? text : `此操作将永久删除${text}, 是否继续?`;
    return new Promise((resolve, reject) => {
        MessageBox.confirm(textInfo, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true,
        })
            .then(() => {
                resolve(true);
            })
            .catch(() => {
                resolve(false);
            });
    });
}
// 数字转汉字 1 - 10
export function returnChinese(num) {
	var units = ['', '十', '百', '千', '万', '十万', '百万', '千万', '亿']
	var digits = ['', '一', '二', '三', '四', '五', '六', '七', '八', '九']

	if (num < 10) {
		return digits[num]
	}

	if (num < 20) {
		return '十' + digits[num - 10]
	}

	var unitIndex = String(num).length - 1
	var unit = units[unitIndex]

	return digits[Math.floor(num / Math.pow(10, unitIndex))] + unit + returnChinese(num % Math.pow(10, unitIndex))
}

//预览地址加密
export function previewUrl(data){
    return data;
    // return Base64.encode(encodeURIComponent(data))
}
